/* eslint no-underscore-dangle: ["error", { "allow": ["_meta"] }] */
import { React } from '@biletiniz/ui-core';
import Head from 'next/head';
import { Layout } from '@biletiniz/ui-layout';
import { NextSeo, FAQPageJsonLd } from '@biletiniz/seo';
import { useTheme } from '@biletiniz/ui-style';
/* eslint-disable import/no-unresolved */
import visaPhoto from '@biletiniz/assets-images/visa-photo.png?webp';
/* eslint-enable import/no-unresolved */
import { useI18n } from '@biletiniz/intl';
import { BackgroundImage } from '@biletiniz/ui-background-image';
import { useRouter } from '@biletiniz/web-app-hooks';
import { LayoutHeader } from '@biletiniz/web-app-components';
import { TravelGuide } from '@biletiniz/web-app-containers';
import { travelGuideFAQ, getCleanFaqJsonid } from '@biletiniz/web-app-utils';

function Content(props) {
  const { lng } = props;
  const i18n = useI18n();
  const theme = useTheme();
  const { router } = useRouter();

  const faq = [
    {
      question: travelGuideFAQ[`${i18n.activeLocale}`].destinations.question,
      answer: travelGuideFAQ[`${i18n.activeLocale}`].destinations.answer,
    },
    {
      question: travelGuideFAQ[`${i18n.activeLocale}`].checklist.question,
      answer: travelGuideFAQ[`${i18n.activeLocale}`].checklist.answer,
    },
    {
      question: travelGuideFAQ[`${i18n.activeLocale}`].guide.question,
      answer: travelGuideFAQ[`${i18n.activeLocale}`].guide.answer,
    },
  ];
  return (
    <Layout mode="natural" backgroundColor="bg.1">
      <NextSeo
        title="Türkiye Seyahat ve Gezi Rehberi: Rotalar & Ulaşım İpuçları | Biletiniz.com"
        description="Türkiye’de gezilecek yerler, popüler rotalar ve uçuş rehberi tek noktada! Yolculukta yanınıza almanız gerekenler ve pratik seyahat ipuçları biletiniz.com'da."
        canonical={`https://biletiniz.com${
          router.locale !== 'tr' ? '/en' : ''
        }/seyahat-rehberi`}
        noindex={lng === 'en'}
        nofollow={false}
      />
      <Head>
        <meta
          name="keywords"
          content="seyahat rehberi, türkiye gezi rehberi, gezilecek yerler, uçuş rehberi, yolculuk ipuçları, popüler tatil rotaları, seyahat blogları, gezi rehberi örneği, biletiniz"
        />
      </Head>
      <FAQPageJsonLd
        mainEntity={faq?.map(item => ({
          questionName: getCleanFaqJsonid(item?.question),
          acceptedAnswerText: getCleanFaqJsonid(item?.answer),
        }))}
      />
      <LayoutHeader router={router} hideNav />
      <BackgroundImage src={visaPhoto} alt="contentPhoto" />
      <Layout.Container width="full">
        <Head>
          <>
            <meta property="og:image" content={visaPhoto} />
            <meta property="og:image:alt" content="posts-background" />
          </>
        </Head>
        <TravelGuide faq={faq} />
      </Layout.Container>
      <Layout.Footer mt={`${theme.space[4] + 10}px`} />
    </Layout>
  );
}

export async function getStaticProps(context) {
  const { default: lngDict = {} } = await import(
    `@biletiniz/intl/locales/${context.locale}.json`
  );
  return {
    props: {
      lng: context.locale,
      lngDict,
    },
  };
}

export default Content;
